export default __webpack_public_path__ + "static/media/01.92923f7f.jpg";